export const environment = {
    production: true,
    loginUrlApi: 'https://tmdj4lert3.execute-api.sa-east-1.amazonaws.com/v1'
  
  };
  